var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageDependentEdit"},[_c('v-toolbar-title',[_vm._v("Editar "+_vm._s(_vm.dependent.name))]),_c('form-dependent',{attrs:{"dependent":_vm.dependent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }